/**
 * sdx-product-card.js — Progressive enhancement for product cards.
 * - 3D tilt on hover (desktop, pointer=fine, no reduced-motion)
 * - Wishlist click no-op stub (prevents anchor propagation; ready for app wiring)
 * Keep minimal (~80 lines).
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function attachTilt(card) {
    var pad = card.querySelector('.sdx-product-card__pad');
    if (!pad) return;
    card.setAttribute('data-sdx-tilt', '');

    var maxDeg = 2.2;

    card.addEventListener('pointermove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;   // 0..1
      var y = (e.clientY - rect.top) / rect.height;   // 0..1
      var rotY = (x - 0.5) * 2 * maxDeg;              // left/right
      var rotX = (0.5 - y) * 2 * maxDeg;              // up/down
      card.style.setProperty('--sdx-tilt-x', rotX.toFixed(2) + 'deg');
      card.style.setProperty('--sdx-tilt-y', rotY.toFixed(2) + 'deg');
    });

    card.addEventListener('pointerleave', function () {
      card.style.setProperty('--sdx-tilt-x', '0deg');
      card.style.setProperty('--sdx-tilt-y', '0deg');
    });
  }

  function attachWishlist(btn) {
    // Stub: prevents bubbling to card link + toggles visual state.
    // Real app (Judge.me/Swym/etc) can replace this handler.
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var pressed = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    });
  }

  function init() {
    var cards = document.querySelectorAll('.sdx-product-card');
    for (var i = 0; i < cards.length; i++) {
      if (hasFinePointer && !prefersReducedMotion) attachTilt(cards[i]);
      var wl = cards[i].querySelector('[data-sdx-wishlist]');
      if (wl) attachWishlist(wl);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
